import api from '@/api'
export default {
  paginate(page, perPage, keyword = '', role = '') {
    return new Promise(function (resolve, reject) {
      api
        .request('get', `/api/v1/users?page=${page}&per_page=${perPage}&keyword=${keyword}&role=${role}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getAllUsers() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/users?limit=999', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  async getAllUsersByRole(role) {
    try {
      let url = '/api/v1/users?limit=999&role=' + role
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async getUsersByRole(role) {
    try {
      let url = '/api/v1/users/by/role/' + role
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async getAllUsersByRoleSource(role, source) {
    try {
      let url = '/api/v1/users?limit=999&role=' + role + '&source=' + source
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async findByRole(clientID) {
    try {
      let url = '/api/v1/users/find/adstrategist/' + clientID
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async createPrivateLink(body) {
    try {
      let url = '/api/v1/users/register-link'
      let response = await api.request('post', url, true, body)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async getLinkedInProfile(handle) {
    const query = encodeURIComponent(handle)
    const response = await api.request('get', `/api/v1/social-data/audience/influencer/linkedin/profile?handle=${query}&refresh=false`, true)
    return response.data
  },
  async getPublicProfile(platform, handle) {
    const query = encodeURIComponent(handle)
    const response = await api.request('get', `/api/v1/social-data/audience/influencer/${platform}/profile?handle=${query}&refresh=false`, true)
    return response.data
  },
  async createCommunityOnboardLink(body) {
    try {
      let url = '/api/v1/users/community/register-link'
      let response = await api.request('post', url, true, body)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async deletePrivateLink(linkID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/users/register-link/' + linkID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  // New user haven't been approved
  async getNewUsers() {
    try {
      let url = '/api/v1/users?isApproved=0'
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  async approveOrReject(action, userId) {
    try {
      let url = '/api/v1/users/approve-reject/' + userId
      let response = await api.request('patch', url, true, {
        action
      })
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },
  getUser(userID) {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/users/' + userID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getUserWordcloud() {
    return new Promise(function (resolve, reject) {
      api
        .request('get', '/api/v1/influencers/wordcloud', true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  createUser(user) {
    return new Promise(function (resolve, reject) {
      api
        .request('post', '/api/v1/users', true, user)
        .then(response => {
          if (!response) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  editUser(user) {
    const userID = user.id
    delete user.id

    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/users/' + userID, true, user)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  changePassword(user) {
    const userID = user.id
    delete user.id

    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/users/change-password/' + userID, true, user)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
          reject(error)
        })
    })
  },
  resetInfPassword(user) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/users/influencer/reset-password', true, user)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          console.log(response.status)
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
          reject(error)
        })
    })
  },
  editProfile(formData) {
    let user;
    for (var pair of formData.entries()) {
      if (pair[0] === 'editProfile') {
        user = JSON.parse(pair[1])
      }
    }
    // const userID = user.id
    // delete user.id

    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/users/' + user.id + '/influencers', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  editInfluencerFromAdmin(formData) {
    return new Promise(function (resolve, reject) {
      api
        .request('patch', '/api/v1/users/update/influencers/byAdmin', true, formData)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  deleteUser(userID) {
    return new Promise(function (resolve, reject) {
      api
        .request('delete', '/api/v1/users/' + userID, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }

          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },

  async validateTokenResetPassword(email, token) {
    try {
      let resp = await api.request('get', '/api/v1/users/reset-password/validate/token/' + email + '/' + token, true)
      return resp
    } catch (error) {
      throw error
    }
  },

  async validatRegisterToken(token) {
    try {
      let resp = await api.request('post', '/api/v1/users/validate/register-token', false, {
        token
      })
      return resp
    } catch (error) {
      throw error
    }
  },

  async resetPassword(data) {
    try {
      let resp = await api.request('post', '/api/v1/users/reset-password', true, data)
      return resp
    } catch (error) {
      throw error
    }
  },

  async sendEmailResetPassword(email, recaptchaToken) {
    try {
      let resp = await api.request('post', '/api/v1/users/forgot-password', false, {
        email,
        recaptchaToken
      })
      return resp
    } catch (error) {
      throw error
    }
  },

  async getPendingTokenRegistrations() {
    try {
      let url = '/api/v1/users/pending-token'
      let response = await api.request('get', url, true)
      if (response.status !== 200) {
        return false
      }

      return response.data
    } catch (error) {
      throw error
    }
  },

  /**
   * Aung
   * Get User by influencer
   * @param {InfluencerID} param
   */
  async getUserByInfluencer(param) {
    try {
      let url = '/api/v1/users/by/influencer'
      let response = await api.request('post', url, true, param)
      if (response.status !== 200) return false

      return response.data
    } catch (error) {
      throw error
    }
  },

  async deleteS3Object(key) {
    try {
      let url = '/api/v1/users/s3/delete'
      let response = await api.request('delete', url, true, {objectKey: key})
      if (response.status !== 200) return false

      return response.data
    } catch (error) {
      throw error
    }
  },

  async checkClientUser(param) {
    try {
      let url = '/api/v1/users/check/client-email'
      let response = await api.request('post', url, true, param)
      if (response.status !== 200) return false

      return response.data
    } catch (error) {
      throw error
    }
  },

  async updateClientUserCampaigns(body) {
    try {
      let url = '/api/v1/users/clients/update/campaigns'
      let response = await api.request('post', url, true, body)
      if (response.status !== 200) return false
      return response.data
    } catch (error) {
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/User/userAPIs.js